import { useEffect, useState } from 'react';
import Sheet from './Sheet';
import SocialButtons, { PROVIDER_LABELS, providerAvailable } from './SocialButtons';
import { useApp } from '../lib/AppContext';

// After an old account logs in with its phone number: asks once per visit to connect one of the sign-in
// providers that are on (Zalo, Google, Apple), so it signs in with one tap from then on. Phone + password keeps
// working.
export default function ConnectPrompt({ legacyPhone }) {
  const { api, native } = useApp();
  const [providers, setProviders] = useState(null);
  const [open, setOpen] = useState(() => {
    try {
      return legacyPhone && !sessionStorage.getItem('connect_prompt_dismissed');
    } catch {
      return legacyPhone;
    }
  });

  useEffect(() => {
    if (open) api.get('/auth/providers').then(setProviders).catch(() => setOpen(false));
  }, [open, api]);

  const close = () => {
    try { sessionStorage.setItem('connect_prompt_dismissed', '1'); } catch { /* private mode */ }
    setOpen(false);
  };
  const names = providers ? Object.keys(PROVIDER_LABELS).filter((p) => providerAvailable(providers, p, native)).map((p) => PROVIDER_LABELS[p]) : [];
  const any = names.length > 0;

  return (
    <Sheet open={open && !!any} onClose={close} title={`Kết nối ${names[0] || 'tài khoản'} để đăng nhập nhanh hơn`}>
      {open && any && (
        <div className="flex flex-col gap-4">
          <p className="text-sm">
            Macro Mate không còn tạo tài khoản bằng số điện thoại. Kết nối {names.join(' hoặc ')} để lần sau đăng
            nhập một chạm. Số điện thoại và mật khẩu vẫn dùng được, nhật ký và mọi dữ liệu của bạn giữ nguyên.
          </p>
          <SocialButtons providers={providers} intent="link" native={native} token={native?.token}
            onDone={() => { close(); window.location.reload(); }} />
          <button type="button" className="btn btn-ghost h-11 rounded-2xl" onClick={close}>Để sau</button>
        </div>
      )}
    </Sheet>
  );
}
